export enum UpdateProgress {
  STALE,
  UPDATING,
  STARTED,
  ERROR,
}
